// extracted by mini-css-extract-plugin
export var deliveryRow = "_sr-a";
export var fixedHeight = "_sr-4";
export var freightLogo = "_sr-9";
export var fullWidth = "_sr-3";
export var priceColumn = "_sr-5";
export var radioSelected = "_sr-7";
export var radioUnselected = "_sr-6";
export var selectedOption = "_sr-2";
export var selectedOptionContainer = "_sr-1";
export var selection = "_sr-0";
export var tallSkeletonText = "_sr-8";